import React from 'react';

const VideoEmbed = ({ youtubeId, title, credit }) => {
  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{ position: 'relative', paddingTop: '56.25%', height: 0 }}>
        <iframe
          src={`https://www.youtube.com/embed/${youtubeId}`}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        ></iframe>
      </div>
      {credit && (
        <p style={{ fontSize: '14px', color: '#555', marginTop: '6px' }}>{title} — {credit}</p>
      )}
    </div>
  );
};

export default VideoEmbed;
